import * as Actions from '../actions'
import * as Validation from '../validation'

Actions.withOperationName(Actions)
Actions.withOperationName(Validation)

export default [
  Actions.startProgress,
  Actions.setMessageIds,
  Actions.setSession,
  Validation.throwOnInvalidSession,
  Actions.configureGateway,
  Actions.loadAppointmentPreloftData,
  Actions.setUserLocale,
  Actions.setTracingContext,
  Actions.chooseCalendarLoftingStrategy,
  Actions.updateProgress('preparing_message'),
]
